import { createAction } from '@reduxjs/toolkit'

 export const setRefreshlist = createAction<{refresh:boolean}>('limit/setRefresh')
 export const setAllowPartDeal = createAction<{allowPartDeal:boolean}>('limitSwap/setAllowPartDeal')
